
/**

	TABLE OF CONTENTS
	---------------------------


	${{TOC}}

*/

/*
 *************************************
 * <!-- Base -->
 *************************************
 */
/* !!! To build a table of contents (TOC), you need to import this scss file into JS */
import '../scss/_style.scss';


export { templateUrl, homeUrl, ajaxUrl } from '@uixkit/core/_global/js/utils/global-vars';
export { UixBrowser } from '@uixkit/core/_global/js/utils/browser';
export { UixModuleInstance } from '@uixkit/core/_global/js/utils/module-instance';
export { UixGUID } from '@uixkit/core/_global/js/utils/GUID';
export { UixMath } from '@uixkit/core/_global/js/utils/math';
export { UixCssProperty } from '@uixkit/core/_global/js/utils/css-property';
export { UixThrottle, UixDebounce } from '@uixkit/core/_global/js/utils/performance';

